<template>
    <div class="d-flex align-items-stretch">
        <parens
            v-if="showParens"
            left />
        <div class="d-flex align-items-center">
            {{ display }}
        </div>
        <parens v-if="showParens" />
    </div>
</template>

<script>
    import base from "./_baseExpression.vue";
    import { isModuleRegistered } from "SharedStores/util";
    import { PROGRAM_TYPES, PROGRAM_NAMESPACE } from "SharedStores/Program/programStore";
    import { PROJECT_TYPES, PROJECT_NAMESPACE } from "SharedStores/Project/projectStore";
    import { isAttachmentInStatus, ATTACHMENT_APPROVAL_STATUS } from "Util/clientAttachment";
    import { BOOLEAN_VALUE } from "Formula/evaluators/boolean";

    export default {
        extends: base,
        computed: {
            display() {
                if (this.expression.PublicAttachmentDefinitionId) {
                    if (!isModuleRegistered(PROGRAM_NAMESPACE, this.$store.state)) {
                        throw Error("program store not registered");
                    }
                    const attachmentDefinition = this.$store.getters[PROGRAM_TYPES.getters.attachmentDefinitionFromId](
                        this.expression.PublicAttachmentDefinitionId
                    );
                    let valueStr = "";
                    if (isModuleRegistered(PROJECT_NAMESPACE, this.$store.state)) {
                        const attachment = this.$store.getters[PROJECT_TYPES.getters.attachmentFromId](
                            this.expression.PublicAttachmentDefinitionId
                        );
                        if (attachment) {
                            // eslint-disable-next-line max-len
                            valueStr = `: ${
                                isAttachmentInStatus(attachment, ATTACHMENT_APPROVAL_STATUS.rejected) ? "Yes" : "No"
                            }`;
                        } else if (this.expression.usingDefault) {
                            const yesOrNo = this.expression.ConstantValue === BOOLEAN_VALUE.false ? "No" : "Yes";
                            valueStr = `: [${yesOrNo}]`;
                        } else {
                            // eslint-disable-next-line max-len
                            return `There is no attachment for '${attachmentDefinition.Name}', and no default value was defined for 'Is Rejected'.`;
                        }
                    }
                    return `Is {${attachmentDefinition.Name}} Rejected${valueStr}`;
                }
                return "Is Attachment Rejected Reference";
            },
            showParens() {
                //Show Parens only Attachment Data field Definition is not set.
                return this.expression.PublicAttachmentDefinitionId === null;
            }
        }
    };
</script>
